__turbopack_context__.v({
  "brand-value": "BrandValuesStrip-module-scss-module___Iwqqa__brand-value",
  "brand-value__caption": "BrandValuesStrip-module-scss-module___Iwqqa__brand-value__caption",
  "brand-value__glyph": "BrandValuesStrip-module-scss-module___Iwqqa__brand-value__glyph",
  "brand-value__icon": "BrandValuesStrip-module-scss-module___Iwqqa__brand-value__icon",
  "brand-value__title": "BrandValuesStrip-module-scss-module___Iwqqa__brand-value__title",
  "brand-values": "BrandValuesStrip-module-scss-module___Iwqqa__brand-values",
  "brand-values__items": "BrandValuesStrip-module-scss-module___Iwqqa__brand-values__items",
});
